import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import { ExpandableBlocks, ContentBlockLoading } from 'components/ContentBlock'
import Filter from './Filter'
import columns from './columns'
import DxDataTable from 'components/DxDataTable'
import { useStatisticsData } from '../helpers'
import { initDayStatistics, getStatisticsData } from '../../gql/getDayStatisticsAsync'

const GROUP_BY_OPTIONS = [
	['Product', 'IntervalField'],
	['IntervalField', 'Product'],
	['Product', 'Shop'],
	['Shop', 'Product'],
	['Total'],
	['Shop', 'Total'],
	['Total', 'Shop'],
]

const EmployeeTime = () => {
	const [expandedId, setExpandedId] = useState(null)
	const [groupBy, setGroupBy] = useState(null)

	const [t] = useTranslation()

	const params = (filterParams) => {
		const { from, to, timeStart, timeEnd, ...rest } = filterParams
		setGroupBy(GROUP_BY_OPTIONS[rest.groupBy])
		const [dateStart] = moment(from).toISOString().split('T')
		const [dateEnd] = moment(to).toISOString().split('T')
		return {
			...rest,
			from: `${dateStart}T${timeStart}`,
			to: `${dateEnd}T${timeEnd}`,
		}
	}

	const { getStatistics, status, data, loading, called } = useStatisticsData({
		getQuery: getStatisticsData,
		initQuery: initDayStatistics,
	})

	const handleSetFilter = (filterParams) => {
		setExpandedId('1')
		getStatistics({ variables: { params: params(filterParams) } })
	}

	return (
		<ExpandableBlocks expandedId={expandedId} onExpand={setExpandedId}>
			<Filter handleSetFilter={handleSetFilter} />
			{called && (
				<ContentBlockLoading isLoading={loading} topBorder alwaysExpanded blockId='1'>
					<DxDataTable
						id='employeeTable'
						label={t('statistic_section.sub_sections.daily_statistics')}
						columns={columns(t)}
						withSearch={false}
						groupBy={groupBy}
						height={508}
						excelExport
						exportFileName={t('statistic_section.sub_sections.daily_statistics')}
						data={data}
						sortByGroupSummaryInfo
						{...(status === 'ERROR' && { noDataText: t('server_errors.request_failed') })}
					/>
				</ContentBlockLoading>
			)}
		</ExpandableBlocks>
	)
}

export default EmployeeTime
